import axiosInstance from "@/api/axiosInstance";

export interface EventAddOnProduct {
  id: string;
  name: string;
  description: string | null;
  iconType: "library" | "upload";
  iconValue: string | null;
  purchaseScope: "company_wide" | "per_seat";
  basePrice: number; // in cents
  availabilityStatus: "not_available" | "available" | "included";
  configuredPrice: number; // in cents
  configSchema: any[];
}

export interface FetchEventAddOnProductsResponse {
  eventId: string;
  addOnProducts: EventAddOnProduct[];
}

export async function fetchEventAddOnProducts(
  eventId: string
): Promise<{ data: FetchEventAddOnProductsResponse }> {
  const response = await axiosInstance.get<FetchEventAddOnProductsResponse>(
    `/api/events/${eventId}/add-on-products`
  );

  return {
    data: response.data,
  };
}
